import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { CustomPageBlockComponent } from './custom-page-block.component';

/**
 * Display a video with the specified URL and alt text.
 */
@Component({
  selector: 'app-custom-page-video',
  template: `<div
    class="mx-auto"
    [ngClass]="{
      'max-w-[60%]': data().size === 'small',
      'max-w-screen-lg': data().size === 'standard',
      'max-w-screen-xl': data().size === 'wide',
      'px-8': data().size !== 'full_width',
    }"
  >
    <video controls [src]="data().url" class="aspect-video w-full"></video>
  </div>`,
  imports: [CommonModule],
  standalone: true,
})
export class CustomPageVideoComponent extends CustomPageBlockComponent<'video'> {}
